import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;

@Component({
    selector: 'wiz-page-posts-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.posts.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PagePostsItemComponent implements OnInit {
    public postId: string = '';
    public tab: string = 'detail';
    public isNew: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");

        this.postId = WizRoute.segment.id || '';
        this.tab = WizRoute.segment.tab || 'detail';

        if (this.postId === 'new') {
            this.tab = 'editor';
            this.postId = '';
            this.isNew = true;
        }

        await this.service.render();
    }

    public onBack() {
        this.service.href('/posts');
    }

    public onEdit(postId: string) {
        this.service.href(`/posts/${postId}/edit`);
    }

    public onSave(postId: string) {
        if (this.isNew) {
            this.service.href('/posts');
        } else {
            this.service.href(`/posts/${postId}`);
        }
    }

    public onCancel() {
        if (this.postId) {
            this.service.href(`/posts/${this.postId}`);
        } else {
            this.service.href('/posts');
        }
    }
}

export default PagePostsItemComponent;